import fs from "fs";
import { Box } from "@chakra-ui/react";
import Head from "next/head";
import { getImageAndTitleFromContent } from "../../../utils/image-title";
import MarkdownContent from "../../../components/markdown-content";
import { getPosts } from "../../../server/get-posts";

export default function Post({
  content,
  image,
  title,
  thumb,
}: {
  content: string;
  image: string;
  title: string;
  thumb: string;
}) {
  return (
    <>
      <Head>
        <title>{`${title} | Talkio AI`}</title>
        <meta property="og:title" content={title} key="title" />
        <meta property="og:image" content={thumb} key="image" />
      </Head>
      <Box>
        <Box
          backgroundColor="#eee"
          bgImage={`url('${image}')`}
          bgPosition="center"
          bgSize="cover"
          bgRepeat="no-repeat"
          w={"100%"}
          maxW="1072px"
          my={5}
          marginLeft="auto"
          marginRight="auto"
          height={{ base: "200px", md: "350px" }}
        ></Box>
        <MarkdownContent>{content}</MarkdownContent>
      </Box>
    </>
  );
}

export async function getStaticProps({ params }: { params: { id: string } }) {
  let content = "";

  try {
    content = fs.readFileSync(`./pages/blog/posts/md/${params.id}.md`, "utf8");

    // todo: use title to create breadcrumb blog > title above image
    const { image, title } = getImageAndTitleFromContent(content);

    return {
      props: {
        content,
        image: `/blog/${image}.top.jpeg`,
        thumb: `/blog/${image}.thumb.jpeg`,
        title,
      },
    };
  } catch (e) {
    content = fs.readFileSync(`./pages/blog/posts/gen-md/${params.id}.md`, "utf8");

    // todo: use title to create breadcrumb blog > title above image
    const { image, title } = getImageAndTitleFromContent(content);

    return {
      props: {
        content,
        image: `/blog/gen-images/${image}.jpeg`,
        thumb: `/blog/gen-images/${image}.jpeg`,
        title,
      },
    };
  }
}

export async function getStaticPaths() {
  const customPosts = getPosts("custom");
  const genPosts = getPosts("gen");

  return {
    paths: [...customPosts, ...genPosts],
    fallback: false,
  };
}
